const COSSubcategory = {
  LANDING_PAGE: 'LANDING_PAGE',
  SITE_PAGE: 'SITE_PAGE',
  BLOG_POST: 'BLOG_POST',
  BLOG_LISTING_PAGE: 'BLOG_LISTING_PAGE',
  WEB_INTERACTIVE: 'WEB_INTERACTIVE'
};
export default COSSubcategory;